import { render } from "./EditJobTitle.vue?vue&type=template&id=22bdeaab"
import script from "./EditJobTitle.vue?vue&type=script&lang=js"
export * from "./EditJobTitle.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__